"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

exports.__esModule = true;
exports.buildCode = buildCode;
exports.memoize = memoize;
exports.loadJS = loadJS;
exports.loadCSS = loadCSS;
exports.initializePlugins = initializePlugins;
exports.persistJS = persistJS;
exports.persistCSS = persistCSS;

var _html = require("./html");

function buildCode(fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var params = args.map(function (arg) {
    if (typeof arg === 'function') return arg.toString();
    return JSON.stringify(arg != null ? arg : null);
  }).join(',');
  return "(".concat(fn.toString(), ")(").concat(params, ")");
}

function memoize(fn) {
  var cache = {};
  return function memoized() {
    var key = "".concat(arguments.length <= 0 ? undefined : arguments[0]);
    var data = cache[key];

    if (!data) {
      data = {
        value: fn.apply(void 0, arguments)
      };
      cache[key] = data;
    }

    return data.value;
  };
}

function createElement(tagName, props, attrs) {
  var el = document.createElement(tagName);

  if (props) {
    Object.entries(props).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      el[key] = value;
    });
  }

  if (attrs) {
    Object.entries(attrs).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      el.setAttribute(key, value);
    });
  }

  return el;
}

var memoizedPreloadJS = memoize(function (url) {
  document.head.append(createElement('link', {
    rel: 'preload',
    as: 'script',
    href: url
  }));
});

function loadJSItem(item, context) {
  if (item.type === 'script') {
    return new Promise(function (resolve, reject) {
      document.head.append(createElement('script', Object.assign(Object.assign({}, item.data), {}, {
        onload: resolve,
        onerror: reject
      })));
    });
  } else if (item.type === 'iife') {
    var _item$data = item.data,
        fn = _item$data.fn,
        getParams = _item$data.getParams;
    fn.apply(void 0, _toConsumableArray((getParams == null ? void 0 : getParams(context)) || []));
  }
}

function loadCSSItem(item) {
  if (item.type === 'style') {
    document.head.append(createElement('style', {
      textContent: item.data
    }));
  } else if (item.type === 'stylesheet') {
    document.head.append(createElement('link', Object.assign({
      rel: 'stylesheet'
    }, item.data)));
  }
}

function loadJS(_x, _x2) {
  return _loadJS.apply(this, arguments);
}

function _loadJS() {
  _loadJS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(items, options) {
    var needPreload, _iterator2, _step2, item;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            needPreload = items.filter(function (item) {
              return item.type === 'script';
            });
            if (needPreload.length > 1) needPreload.forEach(function (item) {
              return memoizedPreloadJS(item.data.src);
            });
            _iterator2 = _createForOfIteratorHelper(items);
            _context.prev = 3;

            _iterator2.s();

          case 5:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 11;
              break;
            }

            item = _step2.value;
            _context.next = 9;
            return loadJSItem(item, options);

          case 9:
            _context.next = 5;
            break;

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](3);

            _iterator2.e(_context.t0);

          case 16:
            _context.prev = 16;

            _iterator2.f();

            return _context.finish(16);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 13, 16, 19]]);
  }));
  return _loadJS.apply(this, arguments);
}

function loadCSS(items) {
  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      loadCSSItem(item);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function initializePlugins(_x3, _x4, _x5) {
  return _initializePlugins.apply(this, arguments);
}

function _initializePlugins() {
  _initializePlugins = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(Markmap, plugins, options) {
    var _iterator3, _step3, initialize;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = Object.assign({}, options);
            _context2.next = 3;
            return Promise.all(plugins.map(function (plugin) {
              loadCSS(plugin.styles);
              return loadJS(plugin.scripts, options);
            }));

          case 3:
            _iterator3 = _createForOfIteratorHelper(plugins);

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                initialize = _step3.value.initialize;
                if (initialize) initialize(Markmap, options);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _initializePlugins.apply(this, arguments);
}

function persistJS(items, context) {
  return items.map(function (item) {
    if (item.type === 'script') return (0, _html.wrapHtml)('script', '', item.data);

    if (item.type === 'iife') {
      var _item$data2 = item.data,
          fn = _item$data2.fn,
          getParams = _item$data2.getParams;
      return (0, _html.wrapHtml)('script', (0, _html.escapeScript)(buildCode.apply(void 0, [fn].concat(_toConsumableArray((getParams == null ? void 0 : getParams(context)) || [])))));
    }
  });
}

function persistCSS(items) {
  return items.map(function (item) {
    if (item.type === 'stylesheet') {
      return (0, _html.wrapHtml)('link', null, Object.assign({
        rel: 'stylesheet'
      }, item.data));
    }
    /* else if (item.type === 'style') */


    return (0, _html.wrapHtml)('style', item.data);
  });
}